"use client";
import React, { memo } from "react";
import { useDebounce } from "react-use";
import { IconButton, InputBase, InputBaseProps, Paper } from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";
import { LoadingButton } from "@mui/lab";
import { cn } from "@onair/utils/cn";

type PropTypes = InputBaseProps & {
	value?: string;
	onSearch?: (v: string) => void;
	loading?: boolean;
	component?: "form" | "div";
};

const InputSearchV2: React.FC<PropTypes> = ({
	value = "",
	onSearch,
	loading,
	className = "",
	component = "div",
	...restProps
}) => {
	const [searchQuery, setSearchQuery] = React.useState(value);

	useDebounce(
		() => {
			onSearch?.(searchQuery);
		},
		500,
		[searchQuery],
	);

	return (
		<Paper
			component={component}
			className={cn("flex items-center w-full px-3 py-2", {
				[className]: className,
			})}
		>
			<IconButton aria-label="menu" className="pointer-events-none p-2">
				{loading ? (
					<Iconify icon="line-md:loading-loop" />
				) : (
					<Iconify icon="eva:search-fill" />
				)}
			</IconButton>
			<InputBase
				sx={{ ml: 1, flex: 1 }}
				placeholder="Tìm kiếm..."
				inputProps={{ "aria-label": "Tìm kiếm..." }}
				{...restProps}
				onChange={(e) => {
					setSearchQuery(e.target.value);
				}}
			/>
		</Paper>
	);
};

export default memo(InputSearchV2);
